// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("./LogIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");

var IOWithUnitError = Relude_IO.WithError({});

var IOWithJsExnError = Relude_IO.WithError({});

function unsafeRunHandledAsync(param) {
  return Relude_IO.unsafeRunAsync((function (param) {
                return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
              }), param);
}

function getRetryDelayedIO(retryCount, io) {
  return Relude_IO.flatMap((function (param) {
                return io;
              }), Relude_IO.delay(Math.imul(170, Relude_Float.floorAsInt(Math.exp(Relude_Int.toFloat(retryCount))))));
}

function retryIO(maximumRetriesOpt, retryCountOpt, io) {
  var maximumRetries = maximumRetriesOpt !== undefined ? maximumRetriesOpt : 5;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
  return Relude_IO.catchError((function (err) {
                if (Curry._2(Relude_Int.greaterThanOrEq, retryCount, maximumRetries)) {
                  return Relude_IO.$$throw(err);
                } else {
                  return retryIO(maximumRetries, retryCount + 1 | 0, getRetryDelayedIO(retryCount, io));
                }
              }), io);
}

function ioWithTapStatus(setStatus, io) {
  var partial_arg = Curry._1(setStatus, Relude_AsyncResult.toIdle);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  var partial_arg$2 = Curry._1(setStatus, Relude_AsyncResult.toIdle);
  var partial_arg$3 = function (param) {
    return Relude_Globals.$$const(partial_arg$2, param);
  };
  var partial_arg$4 = Curry._1(setStatus, Relude_AsyncResult.toBusy);
  var partial_arg$5 = function (param) {
    return Relude_Globals.$$const(partial_arg$4, param);
  };
  return Relude_IO.bitap((function (param) {
                return Relude_Globals.$great$great(partial_arg$1, unsafeRunHandledAsync, param);
              }), (function (param) {
                return Relude_Globals.$great$great(partial_arg$3, unsafeRunHandledAsync, param);
              }), Relude_IO.flatMap((function (param) {
                    return Relude_Globals.$$const(io, param);
                  }), Relude_IO.tap(function (param) {
                        return Relude_Globals.$great$great(partial_arg$5, unsafeRunHandledAsync, param);
                      })(Relude_IO.pure(undefined))));
}

function ioWithStatus(prevStatus, setStatus, io) {
  var partial_arg = Relude_Option.fold(Relude_AsyncResult.loading, Relude_AsyncResult.toBusy, prevStatus);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, setStatus, param);
  };
  return Relude_IO.bitap((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(Relude_AsyncResult.completeOk, setStatus, param);
                            }), unsafeRunHandledAsync, param);
              }), (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(Relude_AsyncResult.completeError, setStatus, param);
                            }), unsafeRunHandledAsync, param);
              }), Relude_IO.flatMap((function (param) {
                    return Relude_Globals.$$const(io, param);
                  }), Relude_IO.tap(function (param) {
                        return Relude_Globals.$great$great(partial_arg$2, unsafeRunHandledAsync, param);
                      })(Relude_IO.pure(undefined))));
}

function runIOUntilCancelled(isCancelledRef, intervalMs, io) {
  return Relude_IO.flatMap((function (param) {
                if (isCancelledRef.contents) {
                  return Relude_IO.pure(undefined);
                } else {
                  return runIOUntilCancelled(isCancelledRef, intervalMs, io);
                }
              }), Relude_IO.withDelayAfter(intervalMs, io));
}

function runIOUntilCancelled$1(intervalMs, io) {
  var isCancelledRef = {
    contents: false
  };
  var cb = function (param) {
    isCancelledRef.contents = true;
    
  };
  return Relude_IO.suspend(function (param) {
              unsafeRunHandledAsync(runIOUntilCancelled(isCancelledRef, intervalMs, io));
              return cb;
            });
}

function runSequenceUntilSome(param) {
  if (!param) {
    return Curry._1(LogIO.pure, undefined);
  }
  var partial_arg = runSequenceUntilSome(param.tl);
  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                return Relude_Option.fold(partial_arg, (function (param) {
                              return Relude_Globals.$great$great(Relude_Option.pure, LogIO.pure, param);
                            }), param);
              }), param.hd);
}

function $$finally(fn, io) {
  return Relude_IO.unsummonError(Relude_IO.flatMap((function (param) {
                    return Relude_Globals.$great$great(fn, Relude_IO.summonError, param);
                  }), Relude_IO.summonError(io)));
}

function biflatMap(handleResult, handleError, io) {
  return $$finally((function (param) {
                return Relude_Result.fold(handleError, handleResult, param);
              }), io);
}

exports.IOWithUnitError = IOWithUnitError;
exports.IOWithJsExnError = IOWithJsExnError;
exports.unsafeRunHandledAsync = unsafeRunHandledAsync;
exports.getRetryDelayedIO = getRetryDelayedIO;
exports.retryIO = retryIO;
exports.ioWithTapStatus = ioWithTapStatus;
exports.ioWithStatus = ioWithStatus;
exports.runIOUntilCancelled = runIOUntilCancelled$1;
exports.runSequenceUntilSome = runSequenceUntilSome;
exports.$$finally = $$finally;
exports.biflatMap = biflatMap;
/* IOWithUnitError Not a pure module */
